import { ITranslation } from "./types";

export const fr: ITranslation = {
  messageFallbacks: {
    homeOrderNotReadyMsg:
      'Vous venez de quitter le magasin? Votre reçu est en cours de traitement, veuillez revenir dans quelque temps.<br/>En cas de problème, contactez le support à l’adresse <a style="white-space: nowrap;" href="mailto:support@aifi.io">support@aifi.io</a>',
    errorReachOutSupportMsg:
      'En cas de problème, contactez le support à <a style="white-space: nowrap;" href="mailto:support@aifi.io">support@aifi.io</a>',
  },
  api: {
    E_FORCED_LOGOUT: `Vous avez été déconnecté car l'accès n'est pas autorisé.`,
  },
  orderStatus: {
    draft: "Brouillon",
    contested: "Contesté",
    paid: "Payé",
    unpaid: "Impayé",
    pending: "En attente",
    reviewed: "Révisé",
    paymentProcessing: "Traitement du paiement",
    refunded: "Remboursé",
    unknown: "Inconnu",
  },
  receiptsList: {
    headings: {
      date: "Date",
      time: "Heure",
      status: "Statut",
      total: "Total",
    },
    action: {
      view: "Voir",
    },
    statusTooltip: {
      draft: "Brouillon - Commande en cours de traitement par le système",
      paid: "Payé - Commande traitée et réglée",
      paymentProcessing:
        "Paiement en cours - Commande traitée et paiement en cours de traitement",
      unpaid: "Impayé - Commande traitée mais paiement échoué",
      pending:
        "En attente - Commande contestée par le client et en attente de révision par le commerçant",
      reviewed:
        "Révisé - Commande contestée par le client et le commerçant a soumis la révision",
    },
  },
  receiptDetailScreen: {
    headerTitle: "Details du reçu",
    subtotal: "Sous-total",
    taxBreakdown: {
      headers: {
        rate: "Tax %",
        netto: "Net",
        brutto: "Brut",
        tax: "Taxe",
        total: "Total:",
      },
    },
    tax: "Taxe",
    taxCRV: "CRV",
    total: "Total",
    processTime: "Temps de traitement",
    orderId: "Ordre ID",
    date: "Date",
    paymentStatus: "Statut de paiement",
    listOfProducts: "Produits",
  },
  receiptDetailComplain: {
    reportProblem: "Signaler un problème",
    submitReview: "Envoyer pour avis",
    confirmTitle: "Reçu envoyé",
    confirmButton: "Fait",
    addMissingItem: "Ajouter un élément manquant",
    addMissingItemMessage: "Ajouter un message (facultatif)",
    form: {
      email: {
        label: 'Comment pouvons-nous vous contacter?',
        placeholder: 'Votre e-mail, ex. me@example.com',
        errors: {
          required: 'L\'adresse e-mail est obligatoire.',
          isEmail: 'Adresse e-mail invalide.',
          inUse: 'L\'adresse e-mail est déjà utilisée.'
        }
      }
    }
  },
  receiptsScreen: {
    minutes: "minutes",
    hours: "heures",
    days: "jours",
    label: {
      contested: "EN REVUE",
      draft: "BROUILLON",
      empty: "VIDER",
      paid: "PAYÉ",
      pending: "EN ATTENTE",
      refunded: "REMBOURSÉ",
      reviewed: "MODIFIÉ",
      unknown: "Inconnu",
      unpaid: "NON PAYÉ",
      paymentProcessing: "Paiement en cours",
    },
    message: {
      contested: "Message contesté",
      draft: "Brouillon de message",
      empty: "Message vide",
      paid: "Message payé",
      pending: "Message en attente",
      refunded: "Message remboursé",
      reviewed: "Message examiné",
      unpaid: "Message non payé",
      paymentProcessing: "Paiement en cours",
    },
  },
  slideModal: {
    close: "Fermer",
    searchPlaceholder: "Rechercher un élément",
  },
  receiptsHome: {
    receiptPortal: "Portail des reçus",
    selectPaymentType:
      "Sélectionnez la méthode préférée pour trouver votre reçu",
    cardBin:
      "Les %{cardBinDigitsCount} premiers chiffres d’un numéro de carte (BIN/IIN)",
    last4: "Les quatre derniers chiffres de votre moyen de paiement",
    last4Apple: "Les quatre derniers chiffres de votre numéro Apple Pay",
    last4Google: "Les quatre derniers chiffres de votre numéro Google Pay",
    instructionApple:
      "Repérez les quatre derniers chiffres de votre numéro de carte Apple Pay dans votre Apple Wallet",
    openWallet: "Ouvrir Wallet",
    instructionGoogle:
      "Repérez les quatre derniers chiffres de votre numéro de carte Google Pay dans votre portefeuille",
    instructionExternalId:
      "Trouvez le numéro de référence de paiement dans votre application de paiement ou votre relevé bancaire.",
    externalIdLabel: "Numéro de référence de paiement",
    externalIdPlaceholder: "",
    expDate: "Date d’expiration",
    visitDate: "Date de votre visite",
    submit: "Récupérer le(s) reçu(s)",
    registerEmail: "Entrez votre e-mail pour recevoir vos futurs reçus",
    registerEmailSuccess: "Adresse e-mail mise à jour avec succès.",
    registerEmailFail:
      "L’adresse e-mail n’a pas été mise à jour car aucun reçu n’est associé aux informations de carte de crédit et/ou à la date de visite fournies.",
    unrecognizedError: "Une erreur inconnue est survenue",
    inconclusiveCardInfo: "Nous ne trouvons pas votre reçu",
    optionalFieldPlaceholder: "Facultatif",
    invalidCaptcha: "Captcha invalide, veuillez réessayer",
    oasisApiError:
      "Impossible de se connecter au serveur des reçus. Veuillez réessayer plus tard.",
  },
};
